import { Box, Button, Grid, Stack, Theme, ToggleButton, ToggleButtonGroup, Typography, useTheme } from '@mui/material';
import { useContext, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { SettingsContext } from '../../store/SettingsContext';
import StatsCardEarningsAll from './StatsCardEarningsAll';
import StatsCardFansActive from './StatsCardFansActive';
import StatsCardFollowingActive from './StatsCardFollowingActive';
import StatsCardTopPerformer from './StatsCardTopPerformer';

const Last7DaysDailyStats = () => {
    const settingsContext = useContext(SettingsContext);
    const params = useParams();
    const theme: Theme = useTheme();
    const [amountType, setAmountType] = useState<'gross' | 'net'>(localStorage.getItem('showEarningsAsGross') === 'true' ? 'gross' : 'net');

    return (
        <Box sx={{ marginTop: 4 }}>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" sx={{ marginBottom: 2 }}>
                <Typography variant="h5">Account Gains</Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Button
                        type="button"
                        component={Link}
                        to={`/subscribers/${params.userId}/${settingsContext.services.sextforce.homeUrl}/metrics/account`}
                        variant="outlined"
                        color="info"
                        size={'medium'}
                        sx={{ height: '37px' }}
                    >
                        More...
                    </Button>
                    <ToggleButtonGroup
                        value={amountType}
                        exclusive
                        color="secondary"
                        size={'small'}
                        onChange={(_event, newValue) => {
                            if (!newValue) {
                                return;
                            }

                            setAmountType(newValue);
                            localStorage.setItem('showEarningsAsGross', newValue === 'gross' ? 'true' : 'false');
                        }}
                        // sx={{ marginTop: '4px', height: '39px' }}
                    >
                        <ToggleButton value="gross" fullWidth sx={{ minWidth: '60px' }}>
                            GROSS
                        </ToggleButton>
                        <ToggleButton value="net" fullWidth sx={{ minWidth: '60px' }}>
                            NET
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Stack>
            </Stack>

            <Grid container spacing={1} flexGrow={0} alignItems="center" justifyContent="center" sx={{ marginBottom: theme.spacing(2) }}>
                <Grid item xs={12} sm={6} md={3}>
                    <StatsCardFansActive />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <StatsCardFollowingActive />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <StatsCardTopPerformer />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <StatsCardEarningsAll amountType={amountType} />
                </Grid>
            </Grid>
        </Box>
    );
};

export default Last7DaysDailyStats;
